module.exports = __webpack_public_path__ + "static/media/eth.153d2c2f.svg";